module.exports = __webpack_public_path__ + "img/logout-red.f0487824.svg";